import { Controller } from "@hotwired/stimulus"

// Page d'attente d'une commande par carte (public/book_orders/banque).
// Interroge l'état de la session Flouci préparée en arrière-plan et envoie
// l'acheteur vers la banque dès qu'elle est prête. 29/10/2026.
//
// Values:
//   url    : /commandes/:token/banque.json
//   retour : la page du livre (repli quand Flouci échoue)
// Targets: attente (indicateur + message), echec (bloc de repli), message
export default class extends Controller {
  static targets = ["attente", "echec", "message"]
  static values = { url: String, retour: String }

  static INTERVALLE_MS = 700
  static PLUS_LONG_MS = 20000   // on prévient, on continue
  static ABANDON_MS = 90000     // au-delà, Flouci n'a pas répondu : repli

  connect() {
    this.debut = Date.now()
    this.parti = false
    this.interroger()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  async interroger() {
    if (this.parti) return
    let etat = null
    try {
      const reponse = await fetch(this.urlValue, { headers: { Accept: "application/json" }, cache: "no-store" })
      if (reponse.ok) etat = await reponse.json()
    } catch (_e) {
      etat = null // réseau momentané : on réessaie
    }

    if (etat?.etat === "prete" && etat.url) {
      this.parti = true
      window.location.assign(etat.url)
      return
    }
    if (etat?.etat === "payee" && etat.suite) {
      this.parti = true
      window.location.assign(etat.suite)
      return
    }
    if (etat?.etat === "echouee" || etat?.etat === "absente") {
      this.montrerEchec()
      return
    }

    const ecoule = Date.now() - this.debut
    if (ecoule > this.constructor.ABANDON_MS) {
      this.montrerEchec()
      return
    }
    if (ecoule > this.constructor.PLUS_LONG_MS && this.hasMessageTarget) {
      this.messageTarget.textContent = "Ça prend plus de temps que prévu, on continue d'essayer. Vous pouvez aussi revenir au livre et choisir un autre moyen."
    }
    this.timer = setTimeout(() => this.interroger(), this.constructor.INTERVALLE_MS)
  }

  montrerEchec() {
    if (this.hasAttenteTarget) this.attenteTarget.hidden = true
    if (this.hasEchecTarget) this.echecTarget.hidden = false
  }
}
